import { useEffect, useState } from "react";
import { MESSAGE } from "Common";
import inventoryApi from "api/inventoryApi";
import { useNavigate } from "react-router-dom";

export const useInventory = () => {

    const [termSearch, setTermSearch] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [dtInvGoods, setDtInvGoods] = useState([]);
    const [reload, setReload] = useState(false);

    const navigate = useNavigate();


    //search site
    useEffect(() => {
        (async function searchInvGoods() {

            try {
                setIsLoading(true);

                /**Call Api */
                const params = {
                    txtSearch: termSearch?.txtSearch || '',
                }
                const dtResponse = await inventoryApi.getInventoryGoods(params);
                const dt = dtResponse?.data['dtInvGoods'] ?? [];
                setDtInvGoods(dt);
            } catch (err) {
                const msg = {
                    contents: [err],
                    type: MESSAGE.ERROR
                }
                setMessage(msg);
            } finally {
                setIsLoading(false);
            }
        })()
    }, [termSearch, reload])

    return { navigate, termSearch, setTermSearch, isLoading, setIsLoading, setReload, message, setMessage, dtInvGoods };

}